import {Component, Input} from "@angular/core";
import {AppSearchFacets} from "../../../models/appSearch.model";

@Component(
        {
            selector: 'catalogue-app-search-toggle-facets-bar',
            templateUrl: './app-search-toggle-facets-bar.component.html'
        }
)
export class AppSearchToggleFacetsBarComponent {
    @Input() public facets: AppSearchFacets[];

    public toggleFacetsBar() {
        if (document.body.classList.contains('filter-sidebar-show')) {
            document.body.classList.remove('filter-sidebar-show');
        } else {
            document.body.classList.add('filter-sidebar-show');
        }
    }
}